__turbopack_context__.v({
  "loading": "FileChooser-module-scss-module__ioVX5W__loading",
  "overlay": "FileChooser-module-scss-module__ioVX5W__overlay",
  "trashFile": "FileChooser-module-scss-module__ioVX5W__trashFile",
});
